<script>
/**
 * 接口地址
 */
const ssoServer =
  process.env.NODE_ENV === "development"
    ? "api"
    : "/api";

// http://47.93.248.226:80/api

/**
 * 本地服务器地址
 */
const natapp = "http://q2q7ya.natappfree.cc";

/**
 * appid
 */
const appid =
  process.env.NODE_ENV === "development"
    ? "wxfe1e9f8ee28d717b"
    : "wx4ab32775667a7326";

export default {
  ssoServer,
  natapp,
  appid,
};
</script>
